// extracted by mini-css-extract-plugin
export default {"modalContainer":"ConfirmModal_modalContainer__3aCEW","modalWrapper":"ConfirmModal_modalWrapper__8Ccy5","urlWrapper":"ConfirmModal_urlWrapper__W4YRe"};